<template>
  <div></div>
</template>

<script lang="ts">

export default {
  name: 'ListBudgets',
}
</script>